module.exports = __webpack_public_path__ + "0a1b3eb13e0fdb23bbf502e460ff5d9a.png";